// extracted by mini-css-extract-plugin
export default {"category":"_5R36OgR9SsPH1MrAj4gzrV"};